export default __webpack_public_path__ + "static/media/Baner-rocket_dao.e2b0bac6.png";